// Que hacer con la puerta legal: bloquear, esperar, o dejar pasar.
//
// La distincion que faltaba es entre "no aplica" y "todavia no se". `applies` exigia
// `orgId`, asi que mientras la organizacion se desconocia la puerta se apagaba entera:
// ni bloqueaba ni esperaba. La app pintaba el contenido y el bloqueo caia encima
// despues -- y en esa ventana se podia navegar y escribir sin haber aceptado nada.
//
// Una decision que depende de la organizacion no se puede tomar mientras la
// organizacion se desconoce. Igual que el rol, un nivel adentro.
export const decidirPuertaLegal = ({
  user,
  isPlatformAdmin,
  orgLoading,
  orgId,
  staff,
  pendientes = [],
  yaActivada,
  puedeFirmar,
  cargandoPendientes,
  esperaAgotada = false,
}) => {
  // El platform_admin no firma por el club: para el la puerta no aplica, y eso es una
  // respuesta, no una espera. Confundirlos lo dejaria mirando el splash para siempre.
  if (!user || isPlatformAdmin) return { estado: 'no-aplica', puedeAceptar: false }

  if (orgLoading) return { estado: 'esperando', puedeAceptar: false }

  // Ya cargo y no hay organizacion: su caso lo resuelve otra pantalla, no esta.
  if (!orgId) return { estado: 'no-aplica', puedeAceptar: false }

  if (cargandoPendientes) return { estado: 'esperando', puedeAceptar: false }

  // El rol puede no llegar NUNCA: si getCurrentStaff falla, useAuth se asienta con
  // sesion puesta y `staff` en null, y nadie reintenta. Esperar sin fin dejaba al
  // usuario en un splash sin salida salvo recargar. La puerta si tiene salida
  // ("Cerrar sesion"), y ante la duda sobre una frontera legal cerrar es mas
  // defendible que abrir. Quien no sabemos que rol tiene tampoco puede aceptar.
  if (!staff) return { estado: esperaAgotada ? 'bloquea' : 'esperando', puedeAceptar: false }

  // El contrato con MYKLUBB lo firma el TITULAR de la cuenta, no cualquier admin: un
  // club con cuatro admins tenia cuatro personas capaces de obligarlo. Si la org no tiene
  // fundador activo, un admin (un club sin nadie facultado quedaria congelado). Lo decide
  // la base para la org activa (_puede_firmar_por_org, la misma regla que revisa el alta
  // de la aceptacion): con marcas globales de la persona (staff.is_founder, staff.rol) la
  // pantalla se equivocaba con quien esta en varias organizaciones.
  const puedeAceptar = !!puedeFirmar

  if (pendientes.length === 0) return { estado: 'libre', puedeAceptar }

  // Una org que nunca acepto nada no esta activa: se bloquea a todos, es el alta. Una
  // que ya operaba y solo tiene una version nueva bloquea SOLO a quien puede
  // resolverla; encerrar a sus coaches convertiria una actualizacion de texto en una
  // caida del servicio.
  const bloquea = !yaActivada || puedeAceptar
  return { estado: bloquea ? 'bloquea' : 'libre', puedeAceptar }
}
